var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 10.5188 1.30625 9.22813 2.5 8.5375V12C2.5 13.1062 3.39375 14 4.5 14C5.60625 14 6.5 13.1031 6.5 12V8.5375C7.69375 9.22813 8.5 10.5219 8.5 12C8.5 14.2094 6.70937 16 4.5 16C2.29063 16 0.5 14.2094 0.5 12Z",
    fill: "#605E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3C5.05312 3 5.5 3.44688 5.5 4V12C5.5 12.5531 5.05312 13 4.5 13C3.94688 13 3.5 12.5531 3.5 12V4C3.5 3.44688 3.94688 3 4.5 3Z",
    fill: "#605E5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2C3.39375 2 2.5 2.89375 2.5 4V7.4625C1.30625 6.77187 0.5 5.47813 0.5 4C0.5 1.79063 2.29063 0 4.5 0C6.70937 0 8.5 1.79063 8.5 4C8.5 5.48125 7.69375 6.77187 6.5 7.4625V4C6.5 2.89375 5.60625 2 4.5 2Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.f14b1b2094e52f856f3c3b8a7530f0c5.svg";
export { ForwardRef as ReactComponent };